import { createFileRoute, Outlet, redirect, Link } from "@tanstack/react-router";
import { checkAdminAccess } from "@/lib/admin/admin.functions";

export const Route = createFileRoute("/admin")({
  beforeLoad: async () => {
    try {
      await checkAdminAccess();
    } catch {
      throw redirect({ to: "/login" });
    }
  },
  head: () => ({
    meta: [{ title: "Painel Admin — Loja EG Elétrica" }, { name: "robots", content: "noindex" }],
  }),
  component: AdminLayout,
});

function AdminLayout() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-8">
      <nav className="mb-6 flex gap-6 border-b border-border pb-4 text-sm font-semibold">
        <Link
          to="/admin"
          activeOptions={{ exact: true }}
          activeProps={{ className: "text-eg-goldtext" }}
          className="text-eg-dark hover:text-eg-goldtext transition-colors"
        >
          Dashboard
        </Link>
        <Link
          to="/admin/produtos"
          activeProps={{ className: "text-eg-goldtext" }}
          className="text-eg-dark hover:text-eg-goldtext transition-colors"
        >
          Produtos
        </Link>
        <Link
          to="/admin/categorias"
          activeProps={{ className: "text-eg-goldtext" }}
          className="text-eg-dark hover:text-eg-goldtext transition-colors"
        >
          Categorias
        </Link>
        <Link
          to="/admin/pedidos"
          activeProps={{ className: "text-eg-goldtext" }}
          className="text-eg-dark hover:text-eg-goldtext transition-colors"
        >
          Pedidos
        </Link>
        <Link
          to="/admin/clientes"
          activeProps={{ className: "text-eg-goldtext" }}
          className="text-eg-dark hover:text-eg-goldtext transition-colors"
        >
          Clientes
        </Link>
        <Link
          to="/admin/cupons"
          activeProps={{ className: "text-eg-goldtext" }}
          className="text-eg-dark hover:text-eg-goldtext transition-colors"
        >
          Cupons
        </Link>
        <Link
          to="/admin/configuracoes"
          activeProps={{ className: "text-eg-goldtext" }}
          className="text-eg-dark hover:text-eg-goldtext transition-colors"
        >
          Configurações
        </Link>
        <Link
          to="/admin/usuarios"
          activeProps={{ className: "text-eg-goldtext" }}
          className="text-eg-dark hover:text-eg-goldtext transition-colors"
        >
          Usuários
        </Link>
        <Link
          to="/admin/integracao-tiny"
          activeProps={{ className: "text-eg-goldtext" }}
          className="text-eg-dark hover:text-eg-goldtext transition-colors"
        >
          Integração Tiny
        </Link>
      </nav>
      <Outlet />
    </div>
  );
}
